import React from 'react';
import { makeStyles, AppBar } from '@material-ui/core';
import { styleBreakDesktop } from '../layouts/Globals';
import { COLOR_WHITE } from '../Material';
import { ReactComponent as Logo } from '../../../resources/images/logo.svg';
import { PATH_LOGIN } from '../../../containers/RoutePaths';

const useStyles = makeStyles(theme => ({
    appBar: {
        background: COLOR_WHITE,
        boxShadow: '0px 1px 4px rgba(186, 186, 186, 0.25)',
        zIndex: '99',
        position: 'relative',
        [styleBreakDesktop(theme)]: {
            position: 'absolute',
        },
    },
    toolBar: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        marginLeft: theme.spacing(3),
        [styleBreakDesktop(theme)]: {
            justifyContent: 'flex-start',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
            marginLeft: theme.spacing(4),
        },
    },
    logo: {
        width: '113px',
        height: '24px',
        cursor: 'pointer',
        [styleBreakDesktop(theme)]: {
            width: '132px',
            height: '28px',
        },
    },
}));

export default function NoLinkAppBar() {
    const classes = useStyles();

    return (
        <AppBar
            classes={{
                root: classes.appBar,
            }}
        >
            <div className={classes.toolBar}>
                <Logo aria-labelledby="logo" className={classes.logo} onClick={() => (window.location = PATH_LOGIN)} />
            </div>
        </AppBar>
    );
};
